import _pipe from "ramda/src/pipe";
import _applyTo from "ramda/src/applyTo";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _unapply from "ramda/src/unapply";
import _identity from "ramda/src/identity";
import _includes from "ramda/src/includes";
import _append from "ramda/src/append";
import _flip from "ramda/src/flip";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _curry from "ramda/src/curry";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _asyncGeneratorDelegate from "@babel/runtime/helpers/asyncGeneratorDelegate";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import 'core-js/modules/es7.symbol.async-iterator';
export var reduce = _curry(function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(pred, acc, iterable) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context.prev = 2;
          _iterator = _asyncIterator(iterable);
        case 4:
          _context.next = 6;
          return _iterator.next();
        case 6:
          if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
            _context.next = 14;
            break;
          }
          item = _step.value;
          _context.next = 10;
          return pred(acc, item);
        case 10:
          acc = _context.sent;
        case 11:
          _iteratorAbruptCompletion = false;
          _context.next = 4;
          break;
        case 14:
          _context.next = 20;
          break;
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](2);
          _didIteratorError = true;
          _iteratorError = _context.t0;
        case 20:
          _context.prev = 20;
          _context.prev = 21;
          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context.next = 25;
            break;
          }
          _context.next = 25;
          return _iterator.return();
        case 25:
          _context.prev = 25;
          if (!_didIteratorError) {
            _context.next = 28;
            break;
          }
          throw _iteratorError;
        case 28:
          return _context.finish(25);
        case 29:
          return _context.finish(20);
        case 30:
          return _context.abrupt("return", acc);
        case 31:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 16, 20, 30], [21,, 25, 29]]);
  }));
  return function (_x21, _x22, _x23) {
    return _ref.apply(this, arguments);
  };
}());
export var toArray = reduce(_flip(_append), []);
export var flatMap = _curry(function () {
  var _flatMap = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee2(pred, iterable) {
    var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _iteratorAbruptCompletion2 = false;
          _didIteratorError2 = false;
          _context2.prev = 2;
          _iterator2 = _asyncIterator(iterable);
        case 4:
          _context2.next = 6;
          return _awaitAsyncGenerator(_iterator2.next());
        case 6:
          if (!(_iteratorAbruptCompletion2 = !(_step2 = _context2.sent).done)) {
            _context2.next = 19;
            break;
          }
          item = _step2.value;
          _context2.t0 = _asyncGeneratorDelegate;
          _context2.t1 = _asyncIterator;
          _context2.next = 12;
          return _awaitAsyncGenerator(pred(item));
        case 12:
          _context2.t2 = _context2.sent;
          _context2.t3 = (0, _context2.t1)(_context2.t2);
          _context2.t4 = _awaitAsyncGenerator;
          return _context2.delegateYield((0, _context2.t0)(_context2.t3, _context2.t4), "t5", 16);
        case 16:
          _iteratorAbruptCompletion2 = false;
          _context2.next = 4;
          break;
        case 19:
          _context2.next = 25;
          break;
        case 21:
          _context2.prev = 21;
          _context2.t6 = _context2["catch"](2);
          _didIteratorError2 = true;
          _iteratorError2 = _context2.t6;
        case 25:
          _context2.prev = 25;
          _context2.prev = 26;
          if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
            _context2.next = 30;
            break;
          }
          _context2.next = 30;
          return _awaitAsyncGenerator(_iterator2.return());
        case 30:
          _context2.prev = 30;
          if (!_didIteratorError2) {
            _context2.next = 33;
            break;
          }
          throw _iteratorError2;
        case 33:
          return _context2.finish(30);
        case 34:
          return _context2.finish(25);
        case 35:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 21, 25, 35], [26,, 30, 34]]);
  }));
  function flatMap(_x, _x2) {
    return _flatMap.apply(this, arguments);
  }
  return flatMap;
}());
export var find = _curry(function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(pred, iterable) {
    var _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, item;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _iteratorAbruptCompletion3 = false;
          _didIteratorError3 = false;
          _context3.prev = 2;
          _iterator3 = _asyncIterator(iterable);
        case 4:
          _context3.next = 6;
          return _iterator3.next();
        case 6:
          if (!(_iteratorAbruptCompletion3 = !(_step3 = _context3.sent).done)) {
            _context3.next = 15;
            break;
          }
          item = _step3.value;
          _context3.next = 10;
          return pred(item);
        case 10:
          if (!_context3.sent) {
            _context3.next = 12;
            break;
          }
          return _context3.abrupt("return", item);
        case 12:
          _iteratorAbruptCompletion3 = false;
          _context3.next = 4;
          break;
        case 15:
          _context3.next = 21;
          break;
        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](2);
          _didIteratorError3 = true;
          _iteratorError3 = _context3.t0;
        case 21:
          _context3.prev = 21;
          _context3.prev = 22;
          if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
            _context3.next = 26;
            break;
          }
          _context3.next = 26;
          return _iterator3.return();
        case 26:
          _context3.prev = 26;
          if (!_didIteratorError3) {
            _context3.next = 29;
            break;
          }
          throw _iteratorError3;
        case 29:
          return _context3.finish(26);
        case 30:
          return _context3.finish(21);
        case 31:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 17, 21, 31], [22,, 26, 30]]);
  }));
  return function (_x24, _x25) {
    return _ref2.apply(this, arguments);
  };
}());
export var map = _curry(function () {
  var _map = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee4(pred, iterable) {
    var _iteratorAbruptCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, item;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _iteratorAbruptCompletion4 = false;
          _didIteratorError4 = false;
          _context4.prev = 2;
          _iterator4 = _asyncIterator(iterable);
        case 4:
          _context4.next = 6;
          return _awaitAsyncGenerator(_iterator4.next());
        case 6:
          if (!(_iteratorAbruptCompletion4 = !(_step4 = _context4.sent).done)) {
            _context4.next = 15;
            break;
          }
          item = _step4.value;
          _context4.next = 10;
          return _awaitAsyncGenerator(pred(item));
        case 10:
          _context4.next = 12;
          return _context4.sent;
        case 12:
          _iteratorAbruptCompletion4 = false;
          _context4.next = 4;
          break;
        case 15:
          _context4.next = 21;
          break;
        case 17:
          _context4.prev = 17;
          _context4.t0 = _context4["catch"](2);
          _didIteratorError4 = true;
          _iteratorError4 = _context4.t0;
        case 21:
          _context4.prev = 21;
          _context4.prev = 22;
          if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
            _context4.next = 26;
            break;
          }
          _context4.next = 26;
          return _awaitAsyncGenerator(_iterator4.return());
        case 26:
          _context4.prev = 26;
          if (!_didIteratorError4) {
            _context4.next = 29;
            break;
          }
          throw _iteratorError4;
        case 29:
          return _context4.finish(26);
        case 30:
          return _context4.finish(21);
        case 31:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 17, 21, 31], [22,, 26, 30]]);
  }));
  function map(_x3, _x4) {
    return _map.apply(this, arguments);
  }
  return map;
}());
export var filter = _curry(function () {
  var _filter = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee5(pred, iterable) {
    var _iteratorAbruptCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, item;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _iteratorAbruptCompletion5 = false;
          _didIteratorError5 = false;
          _context5.prev = 2;
          _iterator5 = _asyncIterator(iterable);
        case 4:
          _context5.next = 6;
          return _awaitAsyncGenerator(_iterator5.next());
        case 6:
          if (!(_iteratorAbruptCompletion5 = !(_step5 = _context5.sent).done)) {
            _context5.next = 16;
            break;
          }
          item = _step5.value;
          _context5.next = 10;
          return _awaitAsyncGenerator(pred(item));
        case 10:
          if (!_context5.sent) {
            _context5.next = 13;
            break;
          }
          _context5.next = 13;
          return item;
        case 13:
          _iteratorAbruptCompletion5 = false;
          _context5.next = 4;
          break;
        case 16:
          _context5.next = 22;
          break;
        case 18:
          _context5.prev = 18;
          _context5.t0 = _context5["catch"](2);
          _didIteratorError5 = true;
          _iteratorError5 = _context5.t0;
        case 22:
          _context5.prev = 22;
          _context5.prev = 23;
          if (!(_iteratorAbruptCompletion5 && _iterator5.return != null)) {
            _context5.next = 27;
            break;
          }
          _context5.next = 27;
          return _awaitAsyncGenerator(_iterator5.return());
        case 27:
          _context5.prev = 27;
          if (!_didIteratorError5) {
            _context5.next = 30;
            break;
          }
          throw _iteratorError5;
        case 30:
          return _context5.finish(27);
        case 31:
          return _context5.finish(22);
        case 32:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[2, 18, 22, 32], [23,, 27, 31]]);
  }));
  function filter(_x5, _x6) {
    return _filter.apply(this, arguments);
  }
  return filter;
}());
export var groupBy = _curry(function (keyFn, list) {
  return reduce(function (acc, elt) {
    var key = keyFn(elt);
    acc[key] = (acc[key] || []).concat(elt);
    return acc;
  }, {}, list);
});
export var uniqBy = _curry(function () {
  var _filter2 = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee6(pred, iterable) {
    var result, _iteratorAbruptCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, item, appliedItem;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          result = [];
          _iteratorAbruptCompletion6 = false;
          _didIteratorError6 = false;
          _context6.prev = 3;
          _iterator6 = _asyncIterator(iterable);
        case 5:
          _context6.next = 7;
          return _awaitAsyncGenerator(_iterator6.next());
        case 7:
          if (!(_iteratorAbruptCompletion6 = !(_step6 = _context6.sent).done)) {
            _context6.next = 19;
            break;
          }
          item = _step6.value;
          _context6.next = 11;
          return _awaitAsyncGenerator(pred(item));
        case 11:
          appliedItem = _context6.sent;
          if (_includes(appliedItem, result)) {
            _context6.next = 16;
            break;
          }
          result.push(appliedItem);
          _context6.next = 16;
          return item;
        case 16:
          _iteratorAbruptCompletion6 = false;
          _context6.next = 5;
          break;
        case 19:
          _context6.next = 25;
          break;
        case 21:
          _context6.prev = 21;
          _context6.t0 = _context6["catch"](3);
          _didIteratorError6 = true;
          _iteratorError6 = _context6.t0;
        case 25:
          _context6.prev = 25;
          _context6.prev = 26;
          if (!(_iteratorAbruptCompletion6 && _iterator6.return != null)) {
            _context6.next = 30;
            break;
          }
          _context6.next = 30;
          return _awaitAsyncGenerator(_iterator6.return());
        case 30:
          _context6.prev = 30;
          if (!_didIteratorError6) {
            _context6.next = 33;
            break;
          }
          throw _iteratorError6;
        case 33:
          return _context6.finish(30);
        case 34:
          return _context6.finish(25);
        case 35:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[3, 21, 25, 35], [26,, 30, 34]]);
  }));
  function filter(_x7, _x8) {
    return _filter2.apply(this, arguments);
  }
  return filter;
}());
export var uniq = uniqBy(_identity);
export var from = map(_identity);
export var of = _unapply(from);
export var splitEvery = _curry(function () {
  var _splitEvery = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee7(size, iterable) {
    var group, _iteratorAbruptCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, item;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          group = [];
          _iteratorAbruptCompletion7 = false;
          _didIteratorError7 = false;
          _context7.prev = 3;
          _iterator7 = _asyncIterator(iterable);
        case 5:
          _context7.next = 7;
          return _awaitAsyncGenerator(_iterator7.next());
        case 7:
          if (!(_iteratorAbruptCompletion7 = !(_step7 = _context7.sent).done)) {
            _context7.next = 17;
            break;
          }
          item = _step7.value;
          group.push(item);
          if (!(group.length === size)) {
            _context7.next = 14;
            break;
          }
          _context7.next = 13;
          return group;
        case 13:
          group = [];
        case 14:
          _iteratorAbruptCompletion7 = false;
          _context7.next = 5;
          break;
        case 17:
          _context7.next = 23;
          break;
        case 19:
          _context7.prev = 19;
          _context7.t0 = _context7["catch"](3);
          _didIteratorError7 = true;
          _iteratorError7 = _context7.t0;
        case 23:
          _context7.prev = 23;
          _context7.prev = 24;
          if (!(_iteratorAbruptCompletion7 && _iterator7.return != null)) {
            _context7.next = 28;
            break;
          }
          _context7.next = 28;
          return _awaitAsyncGenerator(_iterator7.return());
        case 28:
          _context7.prev = 28;
          if (!_didIteratorError7) {
            _context7.next = 31;
            break;
          }
          throw _iteratorError7;
        case 31:
          return _context7.finish(28);
        case 32:
          return _context7.finish(23);
        case 33:
          if (!group.length) {
            _context7.next = 36;
            break;
          }
          _context7.next = 36;
          return group;
        case 36:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[3, 19, 23, 33], [24,, 28, 32]]);
  }));
  function splitEvery(_x9, _x10) {
    return _splitEvery.apply(this, arguments);
  }
  return splitEvery;
}());
export var forEach = _curry(function () {
  var _forEach = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee8(pred, iterable) {
    var _iteratorAbruptCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, item;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _iteratorAbruptCompletion8 = false;
          _didIteratorError8 = false;
          _context8.prev = 2;
          _iterator8 = _asyncIterator(iterable);
        case 4:
          _context8.next = 6;
          return _awaitAsyncGenerator(_iterator8.next());
        case 6:
          if (!(_iteratorAbruptCompletion8 = !(_step8 = _context8.sent).done)) {
            _context8.next = 15;
            break;
          }
          item = _step8.value;
          _context8.next = 10;
          return _awaitAsyncGenerator(pred(item));
        case 10:
          _context8.next = 12;
          return item;
        case 12:
          _iteratorAbruptCompletion8 = false;
          _context8.next = 4;
          break;
        case 15:
          _context8.next = 21;
          break;
        case 17:
          _context8.prev = 17;
          _context8.t0 = _context8["catch"](2);
          _didIteratorError8 = true;
          _iteratorError8 = _context8.t0;
        case 21:
          _context8.prev = 21;
          _context8.prev = 22;
          if (!(_iteratorAbruptCompletion8 && _iterator8.return != null)) {
            _context8.next = 26;
            break;
          }
          _context8.next = 26;
          return _awaitAsyncGenerator(_iterator8.return());
        case 26:
          _context8.prev = 26;
          if (!_didIteratorError8) {
            _context8.next = 29;
            break;
          }
          throw _iteratorError8;
        case 29:
          return _context8.finish(26);
        case 30:
          return _context8.finish(21);
        case 31:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[2, 17, 21, 31], [22,, 26, 30]]);
  }));
  function forEach(_x11, _x12) {
    return _forEach.apply(this, arguments);
  }
  return forEach;
}());
export var take = _curry(function () {
  var _take = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee9(num, iterable) {
    var _iteratorAbruptCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, item;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _iteratorAbruptCompletion9 = false;
          _didIteratorError9 = false;
          _context9.prev = 2;
          _iterator9 = _asyncIterator(iterable);
        case 4:
          _context9.next = 6;
          return _awaitAsyncGenerator(_iterator9.next());
        case 6:
          if (!(_iteratorAbruptCompletion9 = !(_step9 = _context9.sent).done)) {
            _context9.next = 16;
            break;
          }
          item = _step9.value;
          if (!(num <= 0)) {
            _context9.next = 10;
            break;
          }
          return _context9.abrupt("return");
        case 10:
          _context9.next = 12;
          return item;
        case 12:
          num--;
        case 13:
          _iteratorAbruptCompletion9 = false;
          _context9.next = 4;
          break;
        case 16:
          _context9.next = 22;
          break;
        case 18:
          _context9.prev = 18;
          _context9.t0 = _context9["catch"](2);
          _didIteratorError9 = true;
          _iteratorError9 = _context9.t0;
        case 22:
          _context9.prev = 22;
          _context9.prev = 23;
          if (!(_iteratorAbruptCompletion9 && _iterator9.return != null)) {
            _context9.next = 27;
            break;
          }
          _context9.next = 27;
          return _awaitAsyncGenerator(_iterator9.return());
        case 27:
          _context9.prev = 27;
          if (!_didIteratorError9) {
            _context9.next = 30;
            break;
          }
          throw _iteratorError9;
        case 30:
          return _context9.finish(27);
        case 31:
          return _context9.finish(22);
        case 32:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[2, 18, 22, 32], [23,, 27, 31]]);
  }));
  function take(_x13, _x14) {
    return _take.apply(this, arguments);
  }
  return take;
}());
export var exhaust = function () {
  var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee10(iterable) {
    var _iteratorAbruptCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, item;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _iteratorAbruptCompletion10 = false;
          _didIteratorError10 = false;
          _context10.prev = 2;
          _iterator10 = _asyncIterator(iterable);
        case 4:
          _context10.next = 6;
          return _iterator10.next();
        case 6:
          if (!(_iteratorAbruptCompletion10 = !(_step10 = _context10.sent).done)) {
            _context10.next = 11;
            break;
          }
          item = _step10.value;
        case 8:
          _iteratorAbruptCompletion10 = false;
          _context10.next = 4;
          break;
        case 11:
          _context10.next = 17;
          break;
        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](2);
          _didIteratorError10 = true;
          _iteratorError10 = _context10.t0;
        case 17:
          _context10.prev = 17;
          _context10.prev = 18;
          if (!(_iteratorAbruptCompletion10 && _iterator10.return != null)) {
            _context10.next = 22;
            break;
          }
          _context10.next = 22;
          return _iterator10.return();
        case 22:
          _context10.prev = 22;
          if (!_didIteratorError10) {
            _context10.next = 25;
            break;
          }
          throw _iteratorError10;
        case 25:
          return _context10.finish(22);
        case 26:
          return _context10.finish(17);
        case 27:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[2, 13, 17, 27], [18,, 22, 26]]);
  }));
  return function exhaust(_x26) {
    return _ref3.apply(this, arguments);
  };
}();
export var nextOr = _curry(function () {
  var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee11(or, iterator) {
    var _yield$iterator$next, value, done;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          iterator = from(iterator);
          _context11.next = 3;
          return iterator.next();
        case 3:
          _yield$iterator$next = _context11.sent;
          value = _yield$iterator$next.value;
          done = _yield$iterator$next.done;
          return _context11.abrupt("return", done ? or : value);
        case 7:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function (_x27, _x28) {
    return _ref4.apply(this, arguments);
  };
}());
export var next = function () {
  var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee12(iterator) {
    var symbol, out;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          iterator = from(iterator);
          symbol = Symbol('missing value');
          _context12.next = 4;
          return nextOr(symbol, iterator);
        case 4:
          out = _context12.sent;
          if (!(out === symbol)) {
            _context12.next = 7;
            break;
          }
          throw Error('Iterable exhausted');
        case 7:
          return _context12.abrupt("return", out);
        case 8:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function next(_x29) {
    return _ref5.apply(this, arguments);
  };
}();
export var count = function () {
  var _ref6 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee13(iterable) {
    var num, _iteratorAbruptCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          num = 0;
          _iteratorAbruptCompletion11 = false;
          _didIteratorError11 = false;
          _context13.prev = 3;
          _iterator11 = _asyncIterator(iterable);
        case 5:
          _context13.next = 7;
          return _iterator11.next();
        case 7:
          if (!(_iteratorAbruptCompletion11 = !(_step11 = _context13.sent).done)) {
            _context13.next = 13;
            break;
          }
          _ = _step11.value;
          num++;
        case 10:
          _iteratorAbruptCompletion11 = false;
          _context13.next = 5;
          break;
        case 13:
          _context13.next = 19;
          break;
        case 15:
          _context13.prev = 15;
          _context13.t0 = _context13["catch"](3);
          _didIteratorError11 = true;
          _iteratorError11 = _context13.t0;
        case 19:
          _context13.prev = 19;
          _context13.prev = 20;
          if (!(_iteratorAbruptCompletion11 && _iterator11.return != null)) {
            _context13.next = 24;
            break;
          }
          _context13.next = 24;
          return _iterator11.return();
        case 24:
          _context13.prev = 24;
          if (!_didIteratorError11) {
            _context13.next = 27;
            break;
          }
          throw _iteratorError11;
        case 27:
          return _context13.finish(24);
        case 28:
          return _context13.finish(19);
        case 29:
          return _context13.abrupt("return", num);
        case 30:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[3, 15, 19, 29], [20,, 24, 28]]);
  }));
  return function count(_x30) {
    return _ref6.apply(this, arguments);
  };
}();
export var flatten = function () {
  var _flatten = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee14(iterable) {
    var _iteratorAbruptCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, items;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _iteratorAbruptCompletion12 = false;
          _didIteratorError12 = false;
          _context14.prev = 2;
          _iterator12 = _asyncIterator(iterable);
        case 4:
          _context14.next = 6;
          return _awaitAsyncGenerator(_iterator12.next());
        case 6:
          if (!(_iteratorAbruptCompletion12 = !(_step12 = _context14.sent).done)) {
            _context14.next = 12;
            break;
          }
          items = _step12.value;
          return _context14.delegateYield(_asyncGeneratorDelegate(_asyncIterator(items), _awaitAsyncGenerator), "t0", 9);
        case 9:
          _iteratorAbruptCompletion12 = false;
          _context14.next = 4;
          break;
        case 12:
          _context14.next = 18;
          break;
        case 14:
          _context14.prev = 14;
          _context14.t1 = _context14["catch"](2);
          _didIteratorError12 = true;
          _iteratorError12 = _context14.t1;
        case 18:
          _context14.prev = 18;
          _context14.prev = 19;
          if (!(_iteratorAbruptCompletion12 && _iterator12.return != null)) {
            _context14.next = 23;
            break;
          }
          _context14.next = 23;
          return _awaitAsyncGenerator(_iterator12.return());
        case 23:
          _context14.prev = 23;
          if (!_didIteratorError12) {
            _context14.next = 26;
            break;
          }
          throw _iteratorError12;
        case 26:
          return _context14.finish(23);
        case 27:
          return _context14.finish(18);
        case 28:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[2, 14, 18, 28], [19,, 23, 27]]);
  }));
  function flatten(_x15) {
    return _flatten.apply(this, arguments);
  }
  return flatten;
}();
export var tee = _curry(function (n, xs) {
  xs = from(xs);
  return _toConsumableArray(Array(n)).map(function () {
    return [];
  }).map(function () {
    var _tee = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee15(cache, i, caches) {
      var _yield$_awaitAsyncGen, done, value, _iterator14, _step14, _cache;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            if (!true) {
              _context15.next = 17;
              break;
            }
            if (cache.length) {
              _context15.next = 13;
              break;
            }
            _context15.next = 4;
            return _awaitAsyncGenerator(xs.next());
          case 4:
            _yield$_awaitAsyncGen = _context15.sent;
            done = _yield$_awaitAsyncGen.done;
            value = _yield$_awaitAsyncGen.value;
            if (!done) {
              _context15.next = 11;
              break;
            }
            if (!cache.length) {
              _context15.next = 10;
              break;
            }
            return _context15.delegateYield(_asyncGeneratorDelegate(_asyncIterator(cache), _awaitAsyncGenerator), "t0", 10);
          case 10:
            return _context15.abrupt("return");
          case 11:
            _iterator14 = _createForOfIteratorHelper(caches);
            try {
              for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                _cache = _step14.value;
                _cache.push(value);
              }
            } catch (err) {
              _iterator14.e(err);
            } finally {
              _iterator14.f();
            }
          case 13:
            _context15.next = 15;
            return cache.shift();
          case 15:
            _context15.next = 0;
            break;
          case 17:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    function tee(_x16, _x17, _x18) {
      return _tee.apply(this, arguments);
    }
    return tee;
  }());
});
export var takeAfter = _curry(function (pred, iterable) {
  var take = false;
  return filter(function () {
    var _ref7 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee16(item) {
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            if (!take) {
              _context16.next = 2;
              break;
            }
            return _context16.abrupt("return", true);
          case 2:
            _context16.next = 4;
            return pred(item);
          case 4:
            if (!_context16.sent) {
              _context16.next = 6;
              break;
            }
            take = true;
          case 6:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }));
    return function (_x31) {
      return _ref7.apply(this, arguments);
    };
  }(), iterable);
});
export var takeWhile = _curry(function () {
  var _take2 = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee17(pred, iterable) {
    var _iteratorAbruptCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, item;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _iteratorAbruptCompletion13 = false;
          _didIteratorError13 = false;
          _context17.prev = 2;
          _iterator13 = _asyncIterator(iterable);
        case 4:
          _context17.next = 6;
          return _awaitAsyncGenerator(_iterator13.next());
        case 6:
          if (!(_iteratorAbruptCompletion13 = !(_step13 = _context17.sent).done)) {
            _context17.next = 17;
            break;
          }
          item = _step13.value;
          _context17.next = 10;
          return _awaitAsyncGenerator(pred(item));
        case 10:
          if (_context17.sent) {
            _context17.next = 12;
            break;
          }
          return _context17.abrupt("return");
        case 12:
          _context17.next = 14;
          return item;
        case 14:
          _iteratorAbruptCompletion13 = false;
          _context17.next = 4;
          break;
        case 17:
          _context17.next = 23;
          break;
        case 19:
          _context17.prev = 19;
          _context17.t0 = _context17["catch"](2);
          _didIteratorError13 = true;
          _iteratorError13 = _context17.t0;
        case 23:
          _context17.prev = 23;
          _context17.prev = 24;
          if (!(_iteratorAbruptCompletion13 && _iterator13.return != null)) {
            _context17.next = 28;
            break;
          }
          _context17.next = 28;
          return _awaitAsyncGenerator(_iterator13.return());
        case 28:
          _context17.prev = 28;
          if (!_didIteratorError13) {
            _context17.next = 31;
            break;
          }
          throw _iteratorError13;
        case 31:
          return _context17.finish(28);
        case 32:
          return _context17.finish(23);
        case 33:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[2, 19, 23, 33], [24,, 28, 32]]);
  }));
  function take(_x19, _x20) {
    return _take2.apply(this, arguments);
  }
  return take;
}());
export var batchFlatMap = _curry(function (batchSize, fn, xs) {
  return _applyTo(xs, _pipe(splitEvery(batchSize), flatMap(fn)));
});